import React, { useState } from 'react';

const BulkOrderPage = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    contactPerson: '',
    email: '',
    phone: '',
    address: '',
    productInterest: '',
    quantity: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({
      businessName: '',
      contactPerson: '',
      email: '',
      phone: '',
      address: '',
      productInterest: '',
      quantity: '',
      message: ''
    });
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="bg-white min-h-screen">
      <section className="py-20 px-8 md:px-[140px] bg-gradient-to-b from-[#8e0707] to-[#6b0505]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-medium text-white mb-6">
            Bulk Orders & Partnership
          </h1>
          <p className="text-xl text-white/80">
            Interested in placing bulk orders? Let's grow together!
          </p>
        </div>
      </section>

      <section className="py-16 px-8 md:px-[140px]">
        <div className="max-w-2xl mx-auto">
          {submitted ? (
            <div className="p-8 bg-green-50 border border-green-200 rounded-lg text-center">
              <span className="text-4xl mb-4 block">✓</span>
              <h3 className="text-xl font-bold text-green-700 mb-2">Request Received!</h3>
              <p className="text-green-600">We'll contact you within 24 hours.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Business Name *</label>
                  <input
                    type="text"
                    name="businessName"
                    value={formData.businessName}
                    onChange={(e) => setFormData({...formData, businessName: e.target.value})}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Contact Person *</label>
                  <input
                    type="text"
                    name="contactPerson"
                    value={formData.contactPerson}
                    onChange={(e) => setFormData({...formData, contactPerson: e.target.value})}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Phone *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-[#272727] mb-2">Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                  rows={3}
                  className="w-full px-4 py-2 border border-gray-300 rounded"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Product Interest</label>
                  <select
                    name="productInterest"
                    value={formData.productInterest}
                    onChange={(e) => setFormData({...formData, productInterest: e.target.value})}
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  >
                    <option value="">Select Product</option>
                    <option value="mango">Mango Pickle</option>
                    <option value="chili">Chili Pickle</option>
                    <option value="lemon">Lemon Pickle</option>
                    <option value="mixed">Mixed Pickle</option>
                    <option value="all">All Products</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#272727] mb-2">Quantity (kg/month)</label>
                  <input
                    type="number"
                    name="quantity"
                    value={formData.quantity}
                    onChange={(e) => setFormData({...formData, quantity: e.target.value})}
                    min="1"
                    className="w-full px-4 py-2 border border-gray-300 rounded"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-[#272727] mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  rows={4}
                  placeholder="Tell us about your business requirements..."
                  className="w-full px-4 py-2 border border-gray-300 rounded"
                />
              </div>

              <button type="submit" className="w-full bg-[#8e0707] hover:bg-[#6b0505] text-white py-3 text-lg rounded">
                Submit Request
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
};

export default BulkOrderPage;